import { FormFields } from "../contexts/RegistrationContext";
import {
  AGENT_TRIAL_DAYS,
  REGISTRATION_PACKAGE_CODES,
  registrationPlanRequiresPaymentMethod,
} from "./agentRegistrationPlans";
import {
  buildRegistrationReferrerFields,
  REFERRAL_STANDING_CREDIT_RATE_BY_REFERRER,
} from "./agentReferralInvite";

export function isNoCardTrialPackage(packageCode) {
  return (
    String(packageCode || "").trim().toUpperCase() === REGISTRATION_PACKAGE_CODES.TRIAL &&
    !registrationPlanRequiresPaymentMethod(packageCode)
  );
}

/**
 * גוף בקשה ל-POST /api/register-agent/trial — בלי כרטיס, 60 יום, עם שיוך מזמין.
 */
export function buildTrialRegistrationPayload(formData, { packageId, referrerOptions } = {}) {
  const data = formData || {};
  const firstName = String(data[FormFields.PERSONAL_INFO.FIRST_NAME] || "").trim();
  const lastName = String(data[FormFields.PERSONAL_INFO.LAST_NAME] || "").trim();
  const referrer = buildRegistrationReferrerFields(
    data[FormFields.ADDITIONAL_INFO.RECOMMENDED_BY],
    referrerOptions,
  );
  return {
    fullName: `${firstName} ${lastName}`.trim(),
    firstName,
    lastName,
    idNumber: String(data[FormFields.PERSONAL_INFO.NATIONAL_ID] || "").trim(),
    email: data[FormFields.PERSONAL_INFO.EMAIL],
    phone: data[FormFields.PERSONAL_INFO.CELL],
    password: data[FormFields.ACCOUNT_INFO.PASSWORD],
    businessName: data[FormFields.COMPANY_INFO.COMPANY_NAME],
    packageCode: REGISTRATION_PACKAGE_CODES.TRIAL,
    packageId: packageId ?? null,
    trialDays: AGENT_TRIAL_DAYS,
    skipPaymentMethod: true,
    requiresCreditCard: false,
    ...referrer,
    referrerStandingCredit: {
      kind: "standing_monthly",
      startsAfterTrialDays: AGENT_TRIAL_DAYS,
      appliesWhenReferredPackagePaid: true,
      rateByReferrerPackage: REFERRAL_STANDING_CREDIT_RATE_BY_REFERRER,
    },
  };
}

/**
 * כשסוכן בניסיון עובר לחבילה בתשלום — מבקשים מהשרת להפעיל את הזיכוי הקבוע למזמין.
 */
export function buildTrialConversionCreditRequest({ currentPackageCode, targetPackageCode } = {}) {
  if (!isNoCardTrialPackage(currentPackageCode)) return {};
  const target = String(targetPackageCode || "").trim().toUpperCase();
  if (!target || target === "TRIAL") return {};
  return {
    applyReferrerStandingCredit: true,
    referredPaidPackageCode: target,
    creditKind: "standing_monthly",
  };
}
